<template>
  <div class="mt-n4">
    <v-row>
      <v-col cols="12" sm="6">
        <TranslationOptionCard
          v-model="selectedTranslationType"
          data-id="translationTypeSelect_extract"
          translation-type="extract"
          class="my-2 my-sm-4"
          title="Template Translation"
          :price="providerPricing.providerTemplateFee"
          :fee="fee"
          description="NAATI-certified self-service and template translations are used to prove evidence for all official purposes in Australia, including for citizenship or visa applications, etc. Only the relevant information is translated, following official templates."
        />
      </v-col>
      <v-col cols="12" sm="6">
        <TranslationOptionCard
          v-if="providerPricing.supportsAdhoc"
          v-model="selectedTranslationType"
          data-id="translationTypeSelect_fullTranslation"
          translation-type="full-translation"
          class="my-2 my-sm-4"
          title="Full Translation"
          :price="providerPricing.adhocPageFee"
          :fee="fee"
          description="Full translations are exact replications of the foreign-language document, translated into English. Everything is included in the translation. This is suitable when full translations are stated as being a requirement."
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import TranslationOptionCard from './TranslationOptionCard.vue'

export default {
  components: { TranslationOptionCard },
  props: {
    value: { type: String, default: '' },
    providerPricing: { type: Object, required: true },
    fee: { type: Object, required: true }
  },
  data() {
    return {
      selectedTranslationType: ''
    }
  },
  watch: {
    value: {
      handler(value) {
        this.selectedTranslationType = value
      }
    },
    selectedTranslationType: {
      handler(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
<style scoped>
  .translation-option-title {
    font-size: 22.8px;
    text-transform: uppercase;
    color: initial;
    font-weight: bold;
  }
</style>
